module.exports = __webpack_public_path__ + "img/607.429ca752.png";